import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { removeClientsFromGroupStart } from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { decodeHandler, decryptData } from "utils";

function DeleteGroup(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);

  // const [group, setGroup] = React.useState(lState.popup.params.group);
  React.useEffect(() => {
    lMethods.updatePopupParams({
      execute: handleRemoveChange
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleRemoveChange() {
    let data = {
      groupID: lState.popup.params.group.groupKey,
      devices: [
        {
          mirrorID: decryptData(localStorage.getItem("mirrorId")),
          clientUUIDs: lState.popup.params.clientUUIDs
        }
      ]
    };
    props.removeClientsFromGroupStart(data);
    lMethods.closePopup();
    lState.popup.params.resetCheckList();
  }

  return (
    <p className="">
      {"Are you sure you want to remove the selected machine(s) from the  group '" +
        decodeHandler(
          props.groupsObj.list[lState.popup.params.group.groupKey].groupName
        ) +
        "' permanently?"}
    </p>
  );
}

function mapStateToProps(state) {
  return {
    groupsObj: state.dashboard.groups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeClientsFromGroupStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteGroup);
